import { render } from "./PayWall.vue?vue&type=template&id=9f69041e"
import script from "./PayWall.vue?vue&type=script&lang=ts"
export * from "./PayWall.vue?vue&type=script&lang=ts"
script.render = render

export default script